import React from "react"

import { Element } from "legacy/components/shared/base"
import Grid from "legacy/components/shared/Grid"
import {
  InteractiveListType,
  InteractiveListItemType,
} from "types/shared-components"
import ListItem from "./ListItem"
import { Maybe } from "types/Maybe"
import RichText from "legacy/components/shared/RichText"
import useBreakpoints from "src/legacy/hooks/useBreakpoints"

interface OwnProps {
  data: Maybe<InteractiveListType>
}

export type InteractiveListProps = OwnProps

const InteractiveList: React.FC<InteractiveListProps> = ({
  data,
}): React.ReactElement | null => {
  if (!data) return null

  const { breakpoint } = useBreakpoints()
  const { items, primary } = data
  const paddingTop = primary?.reduced_top_padding ? "20" : ["40", "60", "90"]
  const oneColumnDesktop = primary?.one_column_desktop
  const numberOfDesktopColumns = oneColumnDesktop ? "1" : "2"

  const mobileImage = primary?.mobile_background_image?.url
  const mobilePosition = primary?.mobile_background_image_position
  const backgroundImage =
    breakpoint === "sm" && mobileImage
      ? mobileImage
      : primary?.background_image?.url
  const backgroundPosition =
    breakpoint === "sm" || (breakpoint === "md" && mobilePosition)
      ? mobilePosition
      : primary?.background_image_position

  return (
    <Element
      backgroundImage={`url(${backgroundImage})`}
      backgroundPosition={backgroundPosition}
      backgroundRepeat="no-repeat"
      pb={["40", "60", "90"]}
      pt={paddingTop}
      px={["40"]}
    >
      <Grid
        gridGap={["40px", `${oneColumnDesktop ? "100px" : "40px"}`]}
        gridTemplateColumns={[
          "1fr",
          "1fr",
          `repeat(${numberOfDesktopColumns}, 1fr)`,
        ]}
      >
        <Element
          marginTop={oneColumnDesktop ? "60px" : ""}
          textAlign={["inherit", `${oneColumnDesktop ? "center" : "inherit"}`]}
        >
          <RichText render={primary?.wysiwyg?.richText} />
        </Element>
        <Element as="ul">
          {items?.map((item: Maybe<InteractiveListItemType>, index: number) => {
            const isLast = index === items.length - 1
            return <ListItem data={item} isLast={isLast} key={index} />
          })}
        </Element>
      </Grid>
    </Element>
  )
}

export default InteractiveList
